import React, { useState } from 'react';
import { courses } from './plans';
import '../styles/PlanSelector.css';

const PlanSelector = ({ onSelectCourse, initialCourse }) => {
  const [selectedCourse, setSelectedCourse] = useState(initialCourse); // 初期値をinitialCourseに設定

  const handleChange = (event) => {
    const selectedKey = event.target.value;
    setSelectedCourse(selectedKey);  // コースを選択状態に設定
    onSelectCourse(selectedKey);     // 親コンポーネントに通知
  };

  return (
    <div className="elt-wp-plugin cp_ipselect_wrapper">
      <label htmlFor="plan-select" className="cp_ipselect_label">
        コースを選択
      </label>
      <div className="cp_ipselect02">
        <select id="plan-select" onChange={handleChange} value={selectedCourse} required>
          {/* defaultのkeyを初期表示として表示し、選択肢として非表示 */}
          <option value="default" disabled>
            {courses["default"].name} {/* 初期表示としてdefaultのnameを表示 */}
          </option>
          {Object.entries(courses)
            .filter(([key]) => key !== "default") // defaultを除外
            .map(([key, course]) => (
              <option key={key} value={key}>
                {course.name}
              </option>
          ))}
        </select>
      </div>
      <span className="cp_ipselect_message">
        ご希望のコースが見当たらない場合は
        <a href="/contact" className="contact-link">お問合せ</a>ください。
      </span>
    </div>
  );
};

export default PlanSelector;

